import React, { useState } from "react";
import { HttpService } from "../../apiAuthorization/httpService";

export const TeamPro = React.createContext(null);

export const TeamProContext = props => {
    const [taskClassList, setTaskClassList] = useState([]);
    const [noTask, setNoTask] = useState(false);

    const getMobileListTaskClassesByFacilityID = (facilityID) => {
        HttpService.post("/TeamPro/GetMobileListTaskClassesByFacilityID", { FacilityID: facilityID })
            .then((res) => {
                let tasks = [];
                let XMLParser = require('react-xml-parser');
                let xml = new XMLParser().parseFromString(res.Content, "text/xml");
                let functionalAreas = xml.getElementsByTagName('FunctionalArea');

                for (let index = 0; index < functionalAreas.length; index++) {
                    if (functionalAreas[index].attributes["FunctionalAreaID"] === "2") {
                        let list = functionalAreas[index].getElementsByTagName('TaskClass');
                        for (let iIndex = 0; iIndex < list.length; iIndex++) {
                            tasks.push({ TaskClassID: list[iIndex].attributes["TaskClassID"], Brief: list[iIndex].attributes["Brief"] })
                        }
                    }
                }

                setTaskClassList(tasks);
                if (tasks.length === 0) {
                    setNoTask(true);
                }
            });
    }

    return (
        <>
            <TeamPro.Provider value={{ taskClassList, getMobileListTaskClassesByFacilityID, noTask }}>
                {props.children}
            </TeamPro.Provider>
        </>
    );
}
